import { Field, FieldArray } from "formik";
import useCompanyForm from "../hooks/useCompanyForm";
import FileUploadIcon from '../assets/icons/upload_file.svg?react';
import UploadIcon from '../assets/icons/icon_upload.svg?react';
import { FileUpload, XInput, XCheckbox } from '../components';
import XSelect from './common/XSelect';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import Constants from "../Constants";
import { COMPANY_STATUS_MAP, STATES } from "@demandproai/shared";
import DatePickers from "./ui-control/DatePicker";
import XButton from './common/XButton';

const sectionHeaderRowClasses = "flex justify-between items-center w-full! mr-4!";
const passwordToggleClasses = "absolute right-3.75 top-1/2 cursor-pointer";
const accountantEmailRowClasses = "flex mt-2.5";
const domainSuffixClasses = "text-body absolute top-10 left-80";

const CompanyForm = ({ formik }) => {
    const { onProfileUpload,
        toggleShowPassword,
        removeEmailFields,
        toggleDelayedPayment,
        profilefileName,
        showPassword,
        setShowPassword,
        superAdmin
    } = useCompanyForm();

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="border-2 border-dashed border-border rounded-lg py-14 px-10 text-center text-disabled transition-colors duration-300 ease-in-out [&_input[type=file]::file-selector-button]:cursor-pointer [&_input[type=file]::file-selector-button]:mr-3 [&_input[type=file]::file-selector-button]:border [&_input[type=file]::file-selector-button]:border-border [&_input[type=file]::file-selector-button]:bg-white [&_input[type=file]::file-selector-button]:text-content [&_input[type=file]::file-selector-button]:rounded-md [&_input[type=file]::file-selector-button]:px-3 [&_input[type=file]::file-selector-button]:py-1 [&_input[type=file]]:mt-4">
                    {profilefileName?.imageUrl &&
                        <img src={profilefileName?.imageUrl} className="img-fluid" alt="user-logo" />
                    }
                    <div className="mb-6 flex justify-center text-[calc(var(--spacing)*16)] text-subtle">
                        <FileUploadIcon />
                    </div>
                    <p className="text-base text-subtle mb-6">Drag and drop your files here or</p>
                    <div className='inline-block relative'>
                        <XButton
                            variant="outlinePrimary"
                            className="mx-auto!"
                            onClick={() => document.getElementById('fileInput').click()}
                        >
                            <UploadIcon className="text-primary" />
                            Upload
                        </XButton>
                    </div>
                    <Field name="profilepic" component={FileUpload} multipleFileUpload onFileSelected={(files) => onProfileUpload(files, formik)} />
                </div>
            </div>
            <div className="row mt-12!">
                <div className="col-md-6">
                    <div className="form-group">
                        <XInput
                            name="companyName"
                            label="Company Name"
                            {...formik.getFieldProps("companyName")}
                            error={formik.touched.companyName && formik.errors.companyName}
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <XInput
                            name="companyPhonenumber"
                            type="number"
                            label="Company Phone Number"
                            {...formik.getFieldProps("companyPhonenumber")}
                            error={formik.touched.companyPhonenumber && formik.errors.companyPhonenumber}
                        />
                    </div>
                </div>
                <div className="col-md-6 mt-12">
                    <div className="form-group">
                        <XSelect
                            name="status"
                            label="Select Company Status"
                            options={Object.values(COMPANY_STATUS_MAP)}
                            {...formik.getFieldProps("status")}
                        />
                    </div>
                </div>
                <div className="col-md-6 mt-12">
                    <div className="form-group">
                        <XSelect
                            name="homeState"
                            label="Select Default/Home State"
                            options={STATES}
                            {...formik.getFieldProps("homeState")}
                        />
                    </div>
                </div>
                <div className="col-md-6 mt-12">
                    <div className="form-group [&_label]:block! [&_label]:font-sans">
                        <Field name="startedOn" label="Started On" component={DatePickers} />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group mt-12!">
                        <XCheckbox
                            name="isDelayedPayment"
                            label="Is Delayed Payment"
                            checked={!!formik.values.isDelayedPayment}
                            onChange={(e) => toggleDelayedPayment(e, formik)}
                        />
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="form-group">
                        <XInput
                            name="companyAddress"
                            label="Company Address"
                            {...formik.getFieldProps("companyAddress")}
                            error={formik.touched.companyAddress && formik.errors.companyAddress}
                        />
                    </div>
                </div>
            </div>
            <h2>
                <div className={sectionHeaderRowClasses}>
                    <span>Contact Person details</span>
                </div>
            </h2>
            <div className='row'>
                <div className='col-md-6'>
                    <div className="form-group">
                        <XInput
                            name="firstName"
                            label="First Name"
                            {...formik.getFieldProps("firstName")}
                            error={formik.touched.firstName && formik.errors.firstName}
                        />
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className="form-group">
                        <XInput name="lastName" label="Last Name" {...formik.getFieldProps("lastName")}
                            error={formik.touched.lastName && formik.errors.lastName}
                        />
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className="form-group">
                        <XInput name="contactPhonenumber" type="number" label="Contact Phone Number" {...formik.getFieldProps("contactPhonenumber")}
                            error={formik.touched.contactPhonenumber && formik.errors.contactPhonenumber}
                        />
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className="form-group">
                        <XInput name="emailAddress" type="email" label="Email Address" {...formik.getFieldProps("emailAddress")}
                            error={formik.touched.emailAddress && formik.errors.emailAddress}
                        />
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className="form-group relative">
                        <XInput
                            name="databasePassword"
                            type={showPassword ? "text" : "password"}
                            {...formik.getFieldProps("databasePassword")}
                            label="Password"
                            className="form-control pr-12!"
                            error={formik.touched.databasePassword && formik.errors.databasePassword}
                        />
                        <XButton
                            variant="close"
                            onClick={toggleShowPassword}
                            className={passwordToggleClasses}
                            aria-label={showPassword ? "Hide password" : "Show password"}
                        >
                            {showPassword ? <FaEyeSlash size={20} onClick={() => setShowPassword(true)} /> : <FaEye size={20} />}
                        </XButton>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <XSelect
                            name="accountExecutive"
                            label="Account Executive"
                            options={superAdmin}
                            emptyOption="Select Account Executive"
                            {...formik.getFieldProps("accountExecutive")}
                            onChange={(e) => {
                                formik.setFieldValue('accountExecutive', e.target.value);
                            }}
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <XInput
                            name="commission"
                            type="number"
                            label="Commission (%)"
                            {...formik.getFieldProps("commission")}
                            error={formik.touched.commission && formik.errors.commission}
                        />
                    </div>
                </div>
                <div className="col-md-6 mt-12">
                    <XCheckbox
                        name="isAnnual"
                        label="Annual Contract Commission"
                        checked={formik.values.isAnnual}
                        onChange={(e) => formik.setFieldValue('isAnnual', e.target.checked)}
                    />
                </div>
            </div>
            <h2>
                <div className={sectionHeaderRowClasses}>
                    <span>Tier Details</span>
                </div>
            </h2>
            <div className='row'>
                <div className="col-md-6">
                    <div className="form-group">
                        <XSelect
                            name="tier"
                            label="Tier"
                            options={Constants.Dropdowns.Tier}
                            {...formik.getFieldProps('tier')}
                            error={formik.touched.tier && formik.errors.tier}
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <XInput name="tierNotes" label="Tier Notes" {...formik.getFieldProps("tierNotes")} />
                    </div>
                </div>
            </div>
            <h2>
                <div className={sectionHeaderRowClasses}>
                    <span>Company Domain Details</span>
                </div>
            </h2>
            <div className='row'>
                <div className='col-md-6'>
                    <div className="form-group relative">
                        <XInput name="domainName" label="Domain Name" {...formik.getFieldProps("domainName")}
                            error={formik.touched.domainName && formik.errors.domainName}
                        />
                        <span className={domainSuffixClasses}>
                            .demandpro.law
                        </span>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <XInput name="hsCompanyId"
                            label="HubSpot Company ID"
                            {...formik.getFieldProps("hsCompanyId")}
                            error={formik.touched.hsCompanyId && formik.errors.hsCompanyId}
                        />
                    </div>
                </div>
            </div>
            <h2>
                <div className={sectionHeaderRowClasses}>
                    <span>Finance Company Details</span>
                </div>
            </h2>
            <div className='row'>
                <div className='col-md-6'>
                    <div className="form-group">
                        <XInput name="accountantname" label="Accountant Name" {...formik.getFieldProps("accountantname")}
                            error={formik.touched.accountantname && formik.errors.accountantname}
                        />
                    </div>
                </div>
                <div className='col-md-6'>
                    <label className="text-content">Accountant Email</label>
                    <FieldArray
                        name="accountantemail"
                        render={arrayHelpers => (
                            <>
                                <div className="form-group">
                                    {
                                        formik.values.accountantemail.map((_, index) => (
                                            <div className={accountantEmailRowClasses} key={index}>
                                                <XInput name={`accountantemail.${index}`}

                                                    {...formik.getFieldProps(`accountantemail.${index}`)} />
                                                {
                                                    index === 0 &&
                                                    <XButton className="ml-5!" onClick={() => arrayHelpers.push('')}>Add</XButton>
                                                }
                                                {
                                                    index > 0 &&
                                                    <XButton className="ml-5!" onClick={() => removeEmailFields(formik, index)}>Remove</XButton>
                                                }
                                            </div>))
                                    }


                                </div>
                            </>
                        )} />
                </div>
            </div>
        </div>
    )
}

export default CompanyForm;